import React from 'react';

import type { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';

import type {
  MfaGenerateTotpUriKeyParams,
  MfaGenerateTotpUriKeyResult,
  MfaSetupParams,
  MfaValidateSetupUserCodeParams,
  SignInParams,
  SignInResult,
  SignInWithSsoParams,
  SignOutParams,
} from './types';

export type CognitoProviderContextValue = {
  cognitoClient: CognitoIdentityProviderClient | null;
  signIn: (params: SignInParams) => Promise<SignInResult>;
  signInWithSso: (params: SignInWithSsoParams) => Promise<SignInResult>;
  signOut: (params: SignOutParams) => Promise<void>;
  mfaGenerateTotpUriKey: (
    params: MfaGenerateTotpUriKeyParams,
  ) => Promise<MfaGenerateTotpUriKeyResult>;
  mfaValidateSetupUserCode: (params: MfaValidateSetupUserCodeParams) => Promise<void>;
  mfaSetup: (params: MfaSetupParams) => Promise<void>;
};

export const CognitoProviderContext = React.createContext({} as CognitoProviderContextValue);
